import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  BarChart2,
  Users,
  CheckSquare,
  Send,
  CreditCard,
  Clipboard,
  DollarSign,
  Flag,
  Book,
  BookOpen,
  Compass,
  Activity,
  Briefcase,
  Phone,
  Info,
  Shield,
  FileText,
  AlertTriangle,
  UserCheck
} from "react-feather";

function Sidebar({ isOpen }) {
  const [isHovered, setHovered] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [showButton, setShowButton] = useState(true);
  const location = useLocation();
  const { pathname } = location;

  const handleMouseEnter = () => {
    if (!isOpen) {
      setHovered(true);
      setShowButton(true);
    }
  };
  const handleMouseLeave = () => {
    if (!isOpen) {
      setHovered(false);
      setShowButton(false);
    }
  };

  // const isSidebarExpanded = isOpen || isHovered;
const [isBodyCollapsed, setIsBodyCollapsed] = useState(
  document.body.classList.contains("vertical-collapsed")
);
  const isSidebarExpanded = !isBodyCollapsed || isHovered;
useEffect(() => {
  setIsBodyCollapsed(document.body.classList.contains("vertical-collapsed"));
}, [isOpen]);
  const isActive = (path) => {
    return pathname === path || pathname.startsWith(path);
  };

  const handleLinkClick = () => {
    const width = window.innerWidth;
    if (width <= 1200) {
      document.body.classList.remove("sidebar-enable");
    }
  };

  useEffect(() => {
    if (pathname.includes("/userlist") || pathname.includes("/viewUser")) {
      setActiveMenu("users");
    } else if (pathname.includes("/matchlist") || pathname.includes("/viewMatch")) {
      setActiveMenu("matches");
    } else if (pathname.toLowerCase().includes("citizenship")) {
      setActiveMenu("citizenship");
    }
    else if (pathname.toLowerCase().includes("ethnicity")) {
      setActiveMenu("ethnicity");
    }
    else if (pathname.toLowerCase().includes("religious")) {
      setActiveMenu("religious");
    }
    else if (pathname.toLowerCase().includes("education")) {
      setActiveMenu("education");
    }
    else if (pathname.toLowerCase().includes("hobbie")) {
      setActiveMenu("hobbie");
    }
    else if (pathname.toLowerCase().includes("income")) {
      setActiveMenu("income");
    } else if (
      pathname.includes("/contactlist")
    ) {
      setActiveMenu("support");
    } else if (
      pathname.includes("/reportlist")
    ) {
      setActiveMenu("report");
    } else if (pathname.includes("/password")) {
      setActiveMenu("settings");
    } else if (pathname.includes("/sendnotification")) {
      setActiveMenu("sendnotification");
    } 
    // else if (pathname.includes("subscriptionlist") || pathname.includes("updateSubscription") || pathname.includes("addSubscription")) {
    //   setActiveMenu("subscription");
    // } 
    else if (pathname.includes("userSubscriptionslist")) {
      setActiveMenu("usersubscriptions");
    } else if (pathname.includes("transactionlist")) {
      setActiveMenu("transactions"); 
    } else {
      setActiveMenu(null);
    }
  }, [pathname]);

  return (
    <div
      className={`vertical-menu ${isSidebarExpanded ? "hovered" : "collapsed"}`}
      onMouseEnter={() => {
        handleMouseEnter();
        document.body.classList.add("hovered");
      }}
      onMouseLeave={() => {
        handleMouseLeave();
        document.body.classList.remove("hovered");
      }}
    >
      <div className="navbar-brand-box">
        <Link to="/dashboard" className="logo" onClick={handleLinkClick}>
          <div style={{ display: "flex", alignItems: "center",justifyContent:"center",marginRight:"10px" }}>
            <span className="">
              <img
  src="/logo.png"
  alt="logo"
  style={{
    height: isSidebarExpanded ? "50px" : "85px",
    transition: "0.3s ease"
  }}
/>
            </span>
            {/* <h1 style={{ margin: 5, color: "black", fontSize: "26px" }}>MMM</h1> */}
          </div>
        </Link>
        <button
          type="button"
          className="btn btn-sm hide-menu-btn"
          onClick={() => {
            const body = document.body;
            body.classList.toggle("sidebar-enable");
            body.classList.remove("hovered");
            setHovered(false);
            setShowButton(false);

            if (window.innerWidth >= 1200) {
              body.classList.toggle("vertical-collapsed");
               setIsBodyCollapsed(body.classList.contains("vertical-collapsed"));
            } else {
              body.classList.remove("vertical-collapsed");
              setIsBodyCollapsed(false);
            }
          }}
          style={{
            display: isSidebarExpanded && showButton ? "block" : "none",
          }}
        >
          <i className="fe-x"></i>
        </button>
      </div>
      <div data-simplebar="" className="sidebar-menu-scroll mt-1">
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className={isActive("/dashboard") ? "mm-active" : ""}>
              <Link to="/dashboard" onClick={handleLinkClick}>
                <BarChart2/>
                <span>Dashboard</span>
              </Link>
            </li>

          
            <li className={activeMenu === "users" ? "mm-active" : ""}>
              <Link to="/userlist" onClick={handleLinkClick}>
                <Users />
                <span>Users </span>
              </Link>
            </li>
            <li className={activeMenu === "matches" ? "mm-active" : ""}>
              <Link to="/matchlist" onClick={handleLinkClick}>
                <CheckSquare />
                <span>Matches </span>
              </Link>
            </li>
            <li className={activeMenu === "sendnotification" ? "mm-active" : ""}>
              <Link to="/sendnotification" onClick={handleLinkClick}>
                <Send />
                <span>Send Notification </span>
              </Link>
            </li>
            {/* <li className={activeMenu === "subscription" ? "mm-active" : ""}>
              <Link to="/subscriptionlist" onClick={handleLinkClick}>
                <CreditCard />
                <span>Subscriptions </span>
              </Link>
            </li> */}
            <li className={activeMenu === "usersubscriptions" ? "mm-active" : ""}>
              <Link to="/userSubscriptionslist" onClick={handleLinkClick}>
                <Clipboard />
                <span>User Subscriptions </span>
              </Link>
            </li>
            <li className={activeMenu === "transactions" ? "mm-active" : ""}>
              <Link to="/transactionlist" onClick={handleLinkClick}>
                <DollarSign />
                <span>Transactions </span>
              </Link>
            </li>
            {/* <li className={activeMenu === "citizenship" ? "mm-active" : ""}>
              <Link to="/citizenshipList" onClick={handleLinkClick}>
                <Flag />
                <span>Citizenship </span>
              </Link>
            </li> */}
            <li className={activeMenu === "ethnicity" ? "mm-active" : ""}>
              <Link to="/ethnicityList" onClick={handleLinkClick}>
                <Users />
                <span>Ethnicity </span>
              </Link>
            </li>

            <li className={activeMenu === "religious" ? "mm-active" : ""}>
              <Link to="/religiousList" onClick={handleLinkClick}>
                <BookOpen />
                <span>Religious Belief </span>
              </Link>
            </li>

            <li className={activeMenu === "education" ? "mm-active" : ""}>
              <Link to="/educationList" onClick={handleLinkClick}>
                <Book />
                <span>Education </span>
              </Link>
            </li>

            <li className={activeMenu === "hobbie" ? "mm-active" : ""}>
              <Link to="/hobbieList" onClick={handleLinkClick}>
                <Activity />
                <span>Hobbies</span>
              </Link>
            </li>

            <li className={activeMenu === "income" ? "mm-active" : ""}>
              <Link to="/incomeList" onClick={handleLinkClick}>
                <Briefcase />
                <span>Income</span>
              </Link>
            </li>
            <li className={isActive("/contactlist") ? "mm-active" : ""}>
              <Link to="/contactlist" onClick={handleLinkClick}>
                <Phone />
                <span>Contact List</span>
              </Link>
            </li>
            <li className={isActive("/reportlist") ? "mm-active" : ""}>
              <Link to="/reportlist" onClick={handleLinkClick}>
                <AlertTriangle />
                <span>Reports</span>
              </Link>
            </li>
            <li className={isActive("/aboutus") ? "mm-active" : ""}>
              <Link to="/aboutus" onClick={handleLinkClick}>
                <Info />
                <span>Online Dating Safety Tips</span>
              </Link>
            </li>

            <li className={isActive("/privacypolicy") ? "mm-active" : ""}>
              <Link to="/privacypolicy" onClick={handleLinkClick}>
                <Shield />
                <span>Privacy Policy</span>
              </Link>
            </li>

            <li className={isActive("/termsConditions") ? "mm-active" : ""}>
              <Link to="/termsConditions" onClick={handleLinkClick}>
                <FileText />
                <span>Terms & Conditions</span>
              </Link>
            </li>

            <li className={isActive("/childSafety") ? "mm-active" : ""}>
              <Link to="/childSafety" onClick={handleLinkClick}>
                <UserCheck />
                <span>Child Safety</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
